import React from 'react';

const Logo = ({ size = 'medium', showText = true, className = '' }) => {
  const sizes = {
    small: { width: 32, height: 32, fontSize: '18px' },
    medium: { width: 40, height: 40, fontSize: '20px' },
    large: { width: 56, height: 56, fontSize: '24px' }
  };

  const currentSize = sizes[size];

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="relative">
        <svg
          width={currentSize.width}
          height={currentSize.height}
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Washing machine base */}
          <rect
            x="4"
            y="8"
            width="32"
            height="28"
            rx="4"
            fill="#FF385C"
            fillOpacity="0.1"
          />
          
          {/* Washing machine door */}
          <circle
            cx="20"
            cy="22"
            r="10"
            fill="none"
            stroke="#FF385C"
            strokeWidth="2.5"
          />
          
          {/* Inner drum */}
          <circle
            cx="20"
            cy="22"
            r="6"
            fill="none"
            stroke="#FF385C"
            strokeWidth="1.5"
            strokeOpacity="0.6"
          />
          
          {/* Control panel */}
          <rect
            x="8"
            y="12"
            width="24"
            height="3"
            rx="1.5"
            fill="#FF385C"
            fillOpacity="0.3"
          />
          
          {/* Bubbles for friendly touch */}
          <circle cx="12" cy="18" r="1.5" fill="#FF385C" fillOpacity="0.4" />
          <circle cx="28" cy="16" r="1" fill="#FF385C" fillOpacity="0.3" />
          <circle cx="30" cy="26" r="1.5" fill="#FF385C" fillOpacity="0.4" />
          <circle cx="10" cy="28" r="1" fill="#FF385C" fillOpacity="0.3" />
          
          {/* House icon overlay for BnB aspect */}
          <path
            d="M20 4L26 8.5V6H28V10L32 13H30V24H26V18H14V24H10V13H8L20 4Z"
            fill="#FF385C"
            fillOpacity="0.15"
            transform="scale(0.6) translate(13, 8)"
          />
        </svg>
      </div>
      
      {showText && (
        <div className="flex flex-col leading-none">
          <span 
            className="font-semibold text-gray-900"
            style={{ fontSize: currentSize.fontSize }}
          >
            LaundryBnB
          </span>
          <span className="text-xs text-gray-500 font-medium">
            by Washmii
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;